export default __webpack_public_path__ + "static/media/user-group-blue.6b8b30c7.svg";